import { render } from "./TerminalCommandSection.vue?vue&type=template&id=3dc3a26c"
import script from "./TerminalCommandSection.vue?vue&type=script&lang=js"
export * from "./TerminalCommandSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__